import React from 'react';
import { IconButton, Typography } from 'seagull';
import styles from "../ServicesSection.module.scss";
import OngoingServiceSwitch from "./OngoingServiceSwitch";
import { RecurrencePeriodTypes } from "../../../../../models/service-billing/model";
import { serviceBillingModel, serviceModel } from "../../../../../models";
import { BillingTriggerType } from "../../../../../types/api.model";
import { BillingDayOfMonthModel } from "../../../../../models";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { getQboTooltip } from "./ServiceBillingItem.utils";
import { Map } from 'seagull/icons';
const autoBillingCycleMap = {
  weekly: 'each week',
  biweekly: 'every two weeks',
  monthly: 'each month',
  quarterly: 'each quarter',
  yearly: 'each year'
};
const dayOfMonthBullet = (dayOfMonth, recurrencePeriod) => {
  const normalized = BillingDayOfMonthModel.make(dayOfMonth);
  const isQuarter = recurrencePeriod === RecurrencePeriodTypes.Quarterly;
  return {
    text: "Billed on the ".concat(normalized.formatDay()).concat(isQuarter || normalized.isLast() ? ' day' : '', " of ").concat(autoBillingCycleMap[recurrencePeriod])
  };
};
const dayOfWeekWeeklyBullet = dayOfWeek => {
  return {
    text: "Billed every ".concat(dayOfWeek)
  };
};
const dayOfWeekBiWeeklyBullet = dayOfWeek => {
  return {
    text: "Billed every other ".concat(dayOfWeek)
  };
};
export default function AutomaticServiceBillingItem(props) {
  const {
    serviceName,
    serviceId,
    costDisplay,
    billing,
    idx,
    agreement,
    disabled,
    tooltipTitle,
    qboItemName,
    qboClassName
  } = props;
  const billingDayOfWeek = serviceBillingModel.billingDayOfWeek(billing);
  const billingDayOfMonth = serviceBillingModel.billingDayOfMonth(billing);
  const maxCharges = serviceBillingModel.maxCharges(billing);
  const recurrencePeriod = billing.trigger === BillingTriggerType.Ongoing && serviceModel.recurrencePeriod(billing);
  const {
    BILLING_CONTROL_MAP_CALLOUT,
    MAX_CHARGES_ADDED
  } = useFeatureFlags();
  const billingPeriodLabel = recurrencePeriod === RecurrencePeriodTypes.Weekly && billingDayOfWeek && dayOfWeekWeeklyBullet(billingDayOfWeek) || recurrencePeriod === RecurrencePeriodTypes.BiWeekly && billingDayOfWeek && dayOfWeekBiWeeklyBullet(billingDayOfWeek) || recurrencePeriod === RecurrencePeriodTypes.Monthly && billingDayOfMonth && dayOfMonthBullet(billingDayOfMonth, recurrencePeriod) || recurrencePeriod && recurrencePeriod !== RecurrencePeriodTypes.Monthly && recurrencePeriod !== RecurrencePeriodTypes.Weekly && recurrencePeriod !== RecurrencePeriodTypes.BiWeekly && dayOfMonthBullet(serviceBillingModel.isBilledUpfront(billing) ? 1 : 'last', recurrencePeriod);
  return /*#__PURE__*/React.createElement("li", {
    "data-testid": "service-".concat(idx),
    className: styles.serviceBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceDescription
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceName
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    "data-testid": "name"
  }, serviceName), BILLING_CONTROL_MAP_CALLOUT && qboItemName && /*#__PURE__*/React.createElement(IconButton, {
    tooltip: {
      placement: 'top',
      title: getQboTooltip(qboItemName, qboClassName)
    },
    noPadding: true,
    size: "small",
    skin: "primaryTransparent",
    "data-testid": "maunal-service-qbo-synced-".concat(serviceId),
    cursorDefault: true
  }, /*#__PURE__*/React.createElement(Map, {
    className: styles.mapIcon,
    "data-testid": "map-icon-".concat(serviceId)
  }))), /*#__PURE__*/React.createElement(Typography, {
    className: styles.cost,
    noWrap: true,
    variant: "paragraph2",
    skin: "secondary"
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    "data-testid": "cost",
    variant: "paragraph2",
    skin: "secondary"
  }, costDisplay), billingPeriodLabel && /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    "data-testid": "billing",
    variant: "paragraph2",
    skin: "secondary"
  }, billingPeriodLabel.text)), MAX_CHARGES_ADDED && (maxCharges === null || maxCharges === void 0 ? void 0 : maxCharges.enabled) && maxCharges.limit && /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    "data-testid": "max-charges-added-indicator",
    variant: "paragraph2",
    skin: "secondary"
  }, maxCharges.limit - (maxCharges.chargesLeft || 0), "/", maxCharges.limit, " times added")), /*#__PURE__*/React.createElement("div", {
    className: styles.lineItemAction
  }, /*#__PURE__*/React.createElement(OngoingServiceSwitch, {
    "data-testid": "billing-control-service-".concat(idx, "-switch"),
    agreementId: agreement.id,
    serviceId: serviceId,
    serviceName: serviceName,
    isPaused: serviceBillingModel.isPaused(billing),
    isDisabled: disabled,
    tooltipTitle: tooltipTitle
  })));
}